var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-layout',{class:_vm.layoutClasses,attrs:{"layout":"hero","header-styles":_vm.layoutStyles},scopedSlots:_vm._u([{key:"title-header",fn:function(){return [_c('main-title')]},proxy:true}])},[_vm._v(" "),_c('page-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }